// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Returns the an integration
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The integration code
 * @return {String}                        The integration icon
 */
const getIntegrationByCode = ( { integrationCode } ) => {
	// Default response
	let integration = null;

	// Check if the integration exists
	if ( isDefined( UncannyAutomator.integrations[ integrationCode ] ) ) {
		integration = UncannyAutomator.integrations[ integrationCode ];
	}

	return integration;
};

export default getIntegrationByCode;
